
import { defineComponent, reactive, ref } from "vue";
import { Menu } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { ElMessageBox, ElMessage } from "element-plus";
import type { FormInstance, FormRules, PopoverInstance } from "element-plus";
import type Node from "element-plus/es/components/tree/src/model/node";
import { hideModal } from "@/core/helpers/dom";

interface DataForm {
  level: number | null;
  nMaChucNang: number | null;
  parentName: string | null;
  cTenChucNang: string | null;
  nMaChucNangCha: string | null;
  cUrl: string | null;
  cQuyen: string | null;
  nLoai: number | null;
  cIcon: string | null;
  nThuTu: string | null;
  delFlag: string | null;
  cNguoiTao: string | null;
  dNgayTao: string | null;
  cNguoiCapNhatCuoi: string | null;
  dNgayCapNhatCuoi: string | null;
  nTinhTrang: number | null;
  nSystem: number | null;
}

interface Selected {
  level: number | null;
  nMaChucNang: number | null;
  parentName: string | null;
  cTenChucNang: string | null;
  nMaChucNangCha: string | null;
  cUrl: string | null;
  cQuyen: string | null;
  nLoai: number | null;
  cIcon: string | null;
  nThuTu: string | null;
  delFlag: string | null;
  cNguoiTao: string | null;
  dNgayTao: string | null;
  cNguoiCapNhatCuoi: string | null;
  dNgayCapNhatCuoi: string | null;
  nTinhTrang: number | null;
  nSystem: number | null;
  children:Selected[];
}

export default defineComponent({
  name: "kt-modal-menu",
  components: {},
  emits: ["finish"],
  props: {
    data: Object,
    default: Object,
    type: Number,
    action: Number,
    size: String,
    table: Array,
  },
  computed: {
    title() {
      if (this.action == 0) {
        return "Tạo chức năng";
      } else {
        return "Chỉnh sửa chức năng";
      }
    },
    modalType() {
      return ""
      // return this.dataForm["type"];
    },
  },

  setup(props) {
    const menuModalRef = ref<null | HTMLElement>(null);
    const formRef = ref<FormInstance>();
    const popover = ref<PopoverInstance>();
    const store = ref(useStore());
    const router = ref(useRouter());
    const searchLoading = ref<boolean>(false);
    const openDialog = ref<boolean>(false);

    const dataForm = ref<DataForm>(props.data as DataForm);
    const defaultValues = reactive<DataForm>(props.default as DataForm);
    const clearForm = (formEl: FormInstance | undefined) => {
      if (!formEl) return;
      formEl.resetFields();
    };
    const treeProp = ref({
      icon: "icon",
      lastUpdateBy: "lastUpdateBy",
      createBy: "createBy",
      perms: "perms",
      name: "label",
      url: "url",
      children: "children",
      lastUpdateTime: "lastUpdateTime",
      createTime: "createTime",
      level: "level",
      nChucNangNguoiDung: "nChucNangNguoiDung",
      nChucNangQuanTriVien: "nChucNangQuanTriVien",
      type: "type",
      id: "id",
      nMaChucNangCha: "nMaChucNangCha",
      orderNum: "orderNum",
      delFlag: "delFlag",
      parentName: "parentName",
    });
    const rules = reactive<FormRules<DataForm>>({
      cTenChucNang: [
        {
          required: true,
          message: "Xin vui lòng nhập tên chức năng",
          trigger: "blur",
        },
      ],
      cUrl: [
        { required: true, message: "Xin vui lòng nhập url", trigger: "blur" },
      ],
      nLoai: [
        {
          required: true,
          message: "Xin vui lòng chọn loại chức năng",
          trigger: "blur",
        },
      ],
      nThuTu: [
        {
          required: true,
          message: "Xin vui lòng nhập thứ tự",
          trigger: "blur",
        },
      ],
    });
    return {
      menuModalRef,
      formRef,
      popover,
      store,
      router,
      searchLoading,
      openDialog,
      dataForm,
      defaultValues,
      treeProp,
      rules,
      clearForm,
    };
  },
  methods: {
    async handleClose() {
      let DV = this.default as DataForm;
      let DF = this.data as DataForm;
      let check = false;
      for (let prop in DF) {
        check = false;
        if (DF[prop] != DV[prop] && prop != "nMaNhomQuyen") {
          check = true;
          break;
        }
      }

      if (check) {
        ElMessageBox.confirm(
          "Những thay đôi của bạn sẽ không được lưu lại, bạn có chắc muốn thoát ?"
        )
          .then(async () => {
            await this.clearForm(this.formRef);
            hideModal(this.menuModalRef);
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        hideModal(this.menuModalRef);
      }
    },
    renderContent(
      h,
      {
        node,
        data,
        store,
      }: { node: Node; data: Selected; store: Node["store"] }
    ) {
      return h(
        "span",
        {
          class: "custom-tree-node",
        },
        h("span", null, data.cTenChucNang)
      );
    },

    handleNodeClick(val) {
      this.dataForm.nMaChucNangCha = val.nMaChucNang;
      this.dataForm.parentName = val.cTenChucNang;
      if (this.dataForm.cTenChucNang == this.dataForm.parentName) {
        ElMessage({
          message: `Không chọn ${val.cTenChucNang} làm chức năng con của ${val.cTenChucNang}`,
          type: "warning",
        });
      }
    },

    handleSave() {
      this.formRef?.validate((valid) => {
        if (valid) {
          let params = Object.assign({}, this.dataForm);
          this.store.dispatch(Menu.addMenu, params).then((res) => {
            if (res.code == 200) {
              if (this.action == 0)
                ElMessage({
                  message: "Thêm chức năng thành công",
                  type: "success",
                });
              else
                ElMessage({
                  message: "Sửa chức năng thành công",
                  type: "success",
                });

              this.clearForm(this.formRef);
              hideModal(this.menuModalRef);
              this.$emit("finish");
            } else {
              if (this.action == 0)
                ElMessage({
                  message: "Thêm chức năng không thành công",
                  type: "error",
                });
              else
                ElMessage({
                  message: "Sửa chức năng không thành công",
                  type: "error",
                });
            }
          });
        }
      });
    },
  },
});
